// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--admin-s3);
  min-width: 0;
  padding: 0 var(--admin-s4);
  border: 1px solid transparent;
  border-radius: var(--admin-radius-sm);
  background: transparent;
  color: var(--admin-text-primary);
  font: inherit;
  font-size: var(--admin-text-sm);
  font-weight: var(--admin-font-weight-semibold);
  letter-spacing: var(--admin-tracking-tight);
  cursor: pointer;
  text-decoration: none;
  transition:
    background var(--admin-transition-fast),
    border-color var(--admin-transition-fast),
    color var(--admin-transition-fast),
    transform var(--admin-transition-fast);
}

.au-button--sm {
  height: 28px;
}

.au-button--md {
  height: 32px;
}

.au-button--primary {
  background: var(--admin-accent);
  border-color: var(--admin-accent);
  color: var(--admin-accent-ink);
}

.au-button--secondary {
  background: var(--admin-bg-surface-1);
  border-color: rgba(255, 255, 255, 0.12);
  color: var(--admin-text-primary);
}

.au-button--ghost {
  padding-inline: var(--admin-s3);
  color: var(--admin-text-secondary);
}

.au-button--danger {
  background: rgba(248, 113, 113, 0.06);
  border-color: rgba(248, 113, 113, 0.28);
  color: var(--admin-status-critical);
}

.au-button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.au-button--primary:hover:not(:disabled) {
  background: #dc2626;
  border-color: #dc2626;
}

.au-button--secondary:hover:not(:disabled) {
  background: var(--admin-bg-surface-2);
  border-color: rgba(255, 255, 255, 0.16);
}

.au-button--ghost:hover:not(:disabled) {
  background: var(--admin-bg-hover);
  color: var(--admin-text-primary);
}

.au-button--danger:hover:not(:disabled) {
  background: rgba(248, 113, 113, 0.1);
  border-color: rgba(248, 113, 113, 0.42);
}

.au-button:disabled {
  opacity: 0.52;
  cursor: not-allowed;
}

.au-button__icon,
.au-button__label,
.au-button__loading {
  display: inline-flex;
  align-items: center;
}

.au-button__icon svg {
  width: 14px;
  height: 14px;
}

.au-button__loading {
  gap: 1px;
  letter-spacing: 0.2em;
}

.au-button__dot {
  display: inline-block;
  animation: au-button-dot-pulse 900ms infinite;
}

.au-button__dot:nth-child(2) {
  animation-delay: 120ms;
}

.au-button__dot:nth-child(3) {
  animation-delay: 240ms;
}

@keyframes au-button-dot-pulse {
  0%,
  100% {
    opacity: 0.32;
  }
  50% {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .au-button {
    transition: background var(--admin-transition-fast), border-color var(--admin-transition-fast), color var(--admin-transition-fast);
  }

  .au-button:hover:not(:disabled) {
    transform: none;
  }

  .au-button__dot {
    animation: none;
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminButton.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,qCAAqC;EACrC,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,+BAA+B;EAC/B,8CAA8C;EAC9C,2CAA2C;EAC3C,eAAe;EACf,qBAAqB;EACrB;;;;0CAIwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kIAAkI;EACpI;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;AACF","sourcesContent":[".au-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--admin-s3);\n  min-width: 0;\n  padding: 0 var(--admin-s4);\n  border: 1px solid transparent;\n  border-radius: var(--admin-radius-sm);\n  background: transparent;\n  color: var(--admin-text-primary);\n  font: inherit;\n  font-size: var(--admin-text-sm);\n  font-weight: var(--admin-font-weight-semibold);\n  letter-spacing: var(--admin-tracking-tight);\n  cursor: pointer;\n  text-decoration: none;\n  transition:\n    background var(--admin-transition-fast),\n    border-color var(--admin-transition-fast),\n    color var(--admin-transition-fast),\n    transform var(--admin-transition-fast);\n}\n\n.au-button--sm {\n  height: 28px;\n}\n\n.au-button--md {\n  height: 32px;\n}\n\n.au-button--primary {\n  background: var(--admin-accent);\n  border-color: var(--admin-accent);\n  color: var(--admin-accent-ink);\n}\n\n.au-button--secondary {\n  background: var(--admin-bg-surface-1);\n  border-color: rgba(255, 255, 255, 0.12);\n  color: var(--admin-text-primary);\n}\n\n.au-button--ghost {\n  padding-inline: var(--admin-s3);\n  color: var(--admin-text-secondary);\n}\n\n.au-button--danger {\n  background: rgba(248, 113, 113, 0.06);\n  border-color: rgba(248, 113, 113, 0.28);\n  color: var(--admin-status-critical);\n}\n\n.au-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.au-button--primary:hover:not(:disabled) {\n  background: #dc2626;\n  border-color: #dc2626;\n}\n\n.au-button--secondary:hover:not(:disabled) {\n  background: var(--admin-bg-surface-2);\n  border-color: rgba(255, 255, 255, 0.16);\n}\n\n.au-button--ghost:hover:not(:disabled) {\n  background: var(--admin-bg-hover);\n  color: var(--admin-text-primary);\n}\n\n.au-button--danger:hover:not(:disabled) {\n  background: rgba(248, 113, 113, 0.1);\n  border-color: rgba(248, 113, 113, 0.42);\n}\n\n.au-button:disabled {\n  opacity: 0.52;\n  cursor: not-allowed;\n}\n\n.au-button__icon,\n.au-button__label,\n.au-button__loading {\n  display: inline-flex;\n  align-items: center;\n}\n\n.au-button__icon svg {\n  width: 14px;\n  height: 14px;\n}\n\n.au-button__loading {\n  gap: 1px;\n  letter-spacing: 0.2em;\n}\n\n.au-button__dot {\n  display: inline-block;\n  animation: au-button-dot-pulse 900ms infinite;\n}\n\n.au-button__dot:nth-child(2) {\n  animation-delay: 120ms;\n}\n\n.au-button__dot:nth-child(3) {\n  animation-delay: 240ms;\n}\n\n@keyframes au-button-dot-pulse {\n  0%,\n  100% {\n    opacity: 0.32;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .au-button {\n    transition: background var(--admin-transition-fast), border-color var(--admin-transition-fast), color var(--admin-transition-fast);\n  }\n\n  .au-button:hover:not(:disabled) {\n    transform: none;\n  }\n\n  .au-button__dot {\n    animation: none;\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
